
/**
 * Line-only segmentation: chi split theo newline, KHONG split trong dong.
 * Moi dong DOCX = 1 paragraph = 1 segment. Zero false splits.
 */
export const getLineSegments = (text: string): { text: string; start: number; end: number }[] => {
    if (!text || !text.trim()) return [];
    const normalizedText = text.replace(/\r\n/g, '\n');
    const lines = normalizedText.split(/\n+/).filter(line => line.trim());
    const segments: { text: string; start: number; end: number }[] = [];
    let pos = 0;
    for (const line of lines) {
        const start = text.indexOf(line, pos);
        const trimmed = line.trim();
        if (trimmed) {
            segments.push({ text: trimmed, start, end: start + trimmed.length });
        }
        pos = start + line.length;
    }
    return segments;
};

/**
 * Sanitize a project name for use as a folder name.
 * Replaces spaces with underscores.
 */
export const sanitizeFolderName = (name: string, id?: string): string => {
    const sanitized = name
        .trim()
        .replace(/[\\/:*?"<>|]/g, '')  // Remove forbidden FS chars
        .replace(/\s+/g, '_')          // Spaces to underscores
        .replace(/_+/g, '_')           // Collapse multiple underscores
        .replace(/^_|_$/g, '')         // Trim leading/trailing underscores
        .slice(0, 50);                 // Max 50 chars

    if (!sanitized && id) {
        return id.split('-')[0] || id.slice(0, 8);
    }
    return sanitized || 'untitled';
};

/**
 * Sanitize a file name for use in file system.
 * Keeps spaces but removes invalid characters.
 */
export const sanitizeFileName = (name: string): string => {
    return name
        .trim()
        .replace(/[\\/:*?"<>|]/g, '')  // Remove forbidden FS chars
        .slice(0, 60);                 // Max width
};
